import React, { useEffect } from 'react';
import { SearchBox } from '../../../common/sharedComponents/SearchBox';
import { ISelectedOption } from '../../../@types/searchBox';
import { useTranslation } from 'react-i18next';
import { handleOptionClickUtil } from '../../../common/sharedComponents/SearchBox/utils';
import { useSearchUser } from '../../../common/hooks/useSearchUser';
import { TaggedsView } from './../../../common/sharedComponents/TaggedsView';
interface ISearchBoxTaggedUsers {
  callBackSelectedOptions?: (taggedUser: ISelectedOption[]) => void;
  initialState?: ISelectedOption[];
  disabled?: boolean;
}

export function SearchBoxTaggedUsers ({
  callBackSelectedOptions,
  initialState = [],
  disabled = false,
}: ISearchBoxTaggedUsers) {
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
  } = useSearchUser(initialState);

  useEffect(() => {
    if (selectedOptions && selectedOptions.length > 0) {
      if (callBackSelectedOptions) {
        callBackSelectedOptions(selectedOptions);
      }
      setSearchText('');
    }
  }, [selectedOptions]);

  function handleInputChange (value: string) {
    setSearchText(value);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function clearSearch () {
    setSearchText('');
  }

  function removeTag (tagIndex: number) {
    const filteredRemovedTag = selectedOptions.filter(
      (_, index) => index !== tagIndex
    );

    setSelectedOptions(filteredRemovedTag);
    if (callBackSelectedOptions) {
      callBackSelectedOptions(filteredRemovedTag);
    }
  }

  return (
    <>
      {disabled ? (
        <TaggedsView selectedOptions={selectedOptions} />
      ) : (
        <SearchBox
          handleInputChange={handleInputChange}
          searchBoxOptions={searchBoxOptions}
          handleOptionClick={handleOptionClick}
          selectedOptions={selectedOptions}
          searchTextName={searchText}
          clearSearch={clearSearch}
          placeholderText={t(
            'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
          )}
          label={t('COMMON.MY_AUDIT.LABELS.TAGGED')}
          showTags={true}
          removeTag={removeTag}
          disabled={disabled}
        />
      )}
    </>
  );
}
